export const downloadUrl = (url, name) => {
	const a = document.createElement('a');
	document.body.appendChild(a);
	a.download = name || Date.now().toString();
	a.href = url;
	a.click();
	a.remove();
};

export default {};



// WEBPACK FOOTER //
// ./src/modules/shared/utils/download.js